import React, { useCallback, useState } from 'react';
import { Flex } from 'rebass/styled-components';
import { ContactsLinkedInSync } from 'pages/contactsLinkedInSync';
import PropTypes from 'prop-types';
import { Button } from '@getro/rombo';
import { Redirect } from 'react-router-dom';

import { useShareContactsMutation } from '../../../services/userV2';
import { NetworkAdminOnboardingLinkedinSyncActive } from '../components/networkAdminOnboardingLinkedinSyncActive';

export const LinkedIn = ({ handleNextStep, activeNetwork, isExtensionInstalled }) => {
  const [syncStatus, setSyncStatus] = useState(false);
  const [shareContacts, { isLoading: isLoadingShareContacts }] = useShareContactsMutation();

  const handleSyncStatusChange = useCallback(() => {
    setSyncStatus(true);
  }, []);

  const beforeNextStep = (step) => {
    shareContacts({
      collectionId: activeNetwork?.id,
      share: true,
    }).then(() => {
      handleNextStep(step);
    });
  };

  if (isExtensionInstalled) {
    return <Redirect to={`/networks/${activeNetwork.slug}/welcome/onboarding/team`} />;
  }

  return (
    <Flex sx={{ flexDirection: 'column', width: '432px', mx: 'auto', mt: '100px', gap: '16px' }}>
      {!syncStatus && <ContactsLinkedInSync isNetworkAdminOnboarding onSyncStatusChange={handleSyncStatusChange} />}
      <Flex sx={{ flexDirection: 'column', width: '100%', gap: '24px' }}>
        {syncStatus && (
          <NetworkAdminOnboardingLinkedinSyncActive
            handleNextStep={beforeNextStep}
            activeNetwork={activeNetwork}
            isLoadingShareContacts={isLoadingShareContacts}
          />
        )}
        {!syncStatus && (
          <Button
            size="small"
            variant="secondary"
            sx={{ width: '100%', justifyContent: 'center', border: 'none', p: 0, fontSize: '14px' }}
            onClick={() => handleNextStep('linkedin-sync')}
          >
            Skip
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

LinkedIn.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  activeNetwork: PropTypes.object.isRequired,
  isExtensionInstalled: PropTypes.bool,
};

LinkedIn.defaultProps = {
  isExtensionInstalled: false,
};
